import { useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import InputText from '../../../components/Inputs/Text';
import Button from '../../../components/Button';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const SignIn = ({ onSwitch }) => {
    const { signin } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await signin({ email, password });

        if (!result) {
            setError('Email ou senha inválidos.');
        }

        setLoading(false);
    };

    return (
        <div className="auth-form">
            <h2>Entrar</h2>

            <form onSubmit={handleSubmit} className="auth-form-fields">
                <InputText
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!error}
                />
                <InputText
                    label="Senha"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!error}
                    helperText={error}
                    suffix={
                        <IconButton size="small" onClick={() => setShowPassword(v => !v)} edge="end">
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                    }
                />

                {error && <p className="auth-error">{error}</p>}

                <Button
                    label="Entrar"
                    kind="primary"
                    loading={loading}
                    disabled={!email || !password}
                    onClick={handleSubmit}
                />
            </form>

            <p className="auth-switch">
                Não tem uma conta?{' '}
                <span onClick={onSwitch}>Cadastre-se</span>
            </p>
        </div>
    );
};

export default SignIn;
